import { useState, useEffect } from "react"
import { motion } from "framer-motion"
import { Home, Utensils, Train, Sparkles, PieChart, Landmark, ShoppingBag } from "lucide-react"
import "./CostOfLiving.css"

const CostOfLiving = ({ countryData }) => {
  const { costOfLiving = {} } = countryData
  const {
    gaugePosition = 0,
    expances = [],
    breakdown = []
  } = costOfLiving

  const [needlePosition, setNeedlePosition] = useState(-90)

  useEffect(() => {
    const timer = setTimeout(() => {
      setNeedlePosition(Number(gaugePosition) - 90)
    }, 800)
    return () => clearTimeout(timer)
  }, [gaugePosition])

  const expenseIcons = {
    "Rent": Home,
    "Food": Utensils,
    "Transport": Train,
    "Misc": Sparkles,
    "Default": ShoppingBag
  }

  return (
    <div className="cost-living-container">
      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        Living Experience in {countryData?.name}
      </motion.h1>

      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        className="cost-of-living-section"
      >
        <h2><PieChart size={24} color="#06b6d4" /> Cost Of Living Index</h2>
        <div className="cost-gauge">
          <div className="gauge-container">
            <div className="gauge">
              <motion.div
                initial={{ rotate: -90 }}
                animate={{ rotate: needlePosition }}
                transition={{ duration: 1.5, ease: "easeOut" }}
                className="gauge-needle"
              ></motion.div>
            </div>
            <div className="gauge-labels">
              <span className="low">Affordable</span>
              <span className="high">Premium</span>
            </div>
          </div>
        </div>
      </motion.div>

      <div className="monthly-expenses-section">
        <h2><Landmark size={24} color="#a855f7" /> Estimated Monthly Expenses</h2>
        <div className="expenses-grid">
          {expances.map((expense, index) => {
            const Icon = expenseIcons[expense.category] || expenseIcons.Default
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                viewport={{ once: true }}
                className="expense-card"
              >
                <div className="expense-icon">
                  <Icon size={24} />
                </div>
                <h3>{expense.category}</h3>
                <p className="expense-range">{expense.range}</p>
              </motion.div>
            )
          })}
        </div>
      </div>

      <div className="living-costs-breakdown">
        <h2><ShoppingBag size={24} color="#fbbf24" /> Detailed Cost Breakdown</h2>
        <div className="cost-breakdown-grid">
          {breakdown.map((section, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, x: idx % 2 === 0 ? -20 : 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="cost-category"
            >
              <h3>{section.category}</h3>
              <div className="cost-item">
                <span>{section.items.name}</span>
                <span>{section.items.cost}</span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default CostOfLiving
